import { Button, Descriptions, Spin } from 'antd';
import { Routes } from 'business/router/constants';
import { Link, useSearchParams } from 'react-router';
import {
  formatDate,
  formatDateWithMiddleDot,
} from 'technical/format/date-format';
import { useTranslation } from 'translations/hooks';
import { ContentHeader } from 'ui/components/content-header';
import { MainCard } from 'ui/components/main-card';
import { RepairEntry } from './components/repair-entry';
import { useGetQuarantineDefectsData } from './hooks/data/use-get-quarantine-defects';

export const ReceiptRepairPendingPage = () => {
  const { t } = useTranslation();

  const [searchParams] = useSearchParams();

  const id = searchParams.get('id');
  const serialNumber = searchParams.get('serialNumber');
  const segmentType = searchParams.get('segmentType');
  const manufactureDate = searchParams.get('manufactureDate');
  const currentStatus = searchParams.get('status');
  const lastScanSite = searchParams.get('scanSite');

  const { data: quarantineDefects, isLoading } = useGetQuarantineDefectsData(
    id ?? '',
  );

  const items = [
    {
      key: 'serialNumber',
      label: t('chooseSegmentStatus.details.serialNumber'),
      children: serialNumber,
    },
    {
      key: 'segmentType',
      label: t('chooseSegmentStatus.details.segmentType'),
      children: segmentType ?? '-',
    },
    {
      key: 'manufactureDate',
      label: t('chooseSegmentStatus.details.manufactureDate'),
      children: formatDateWithMiddleDot(manufactureDate),
    },
    {
      key: 'status',
      label: t('chooseSegmentStatus.details.status'),
      children: currentStatus
        ? t(`chooseSegmentStatus.status.state`, { context: currentStatus })
        : '-',
    },
    {
      key: 'scanSite',
      label: t('chooseSegmentStatus.details.scanSite'),
      children: lastScanSite ?? '-',
    },
  ];

  return (
    <ContentHeader title={t('receipt.repair.title')}>
      <div className="bg-white px-12 py-2">
        <Descriptions
          items={items}
          colon={false}
          layout="vertical"
          column={3}
        />
      </div>
      <div className="flex w-full flex-1 flex-col justify-between p-4">
        <MainCard>
          <div className="mb-2 flex rounded-xl border border-gray-200 bg-gray-50 px-6 py-4 font-medium">
            <div className="w-1/3">{t('receipt.repair.date')}</div>
            <div className="flex-1">{t('receipt.repair.defect')}</div>
          </div>

          <div className="flex flex-col justify-center gap-2">
            {isLoading ? (
              <Spin size="small" />
            ) : (
              quarantineDefects?.defects?.map((defect) => (
                <RepairEntry
                  key={defect.id}
                  label={defect.label}
                  date={formatDate(defect.date)}
                  defectId={defect.id}
                  serialNumber={serialNumber ?? ''}
                  segmentType={segmentType ?? ''}
                />
              ))
            )}
          </div>
        </MainCard>

        <Link to={Routes.App}>
          <Button
            color="primary"
            variant="outlined"
            className="w-full"
            htmlType="submit"
          >
            {t('common.cancel')}
          </Button>
        </Link>
      </div>
    </ContentHeader>
  );
};
